
import { makeDataHeader } from '../common/comutil';

class ObjTrSet {

    constructor(name) {
        this.TrSetName = name;
        this.Action = "";
        this.KeyValue = "";
        //this.Parameters = "";
        this.CountDataSets = 0;
        this.moduleName = "";
        this.methodName = "";
        //this.CallMethod = "";
        this.tranID = "";
        this.tranMethod = "";
        this.suiParam = "";
        this.retParam = "";
        this.DataSets = [];

        this.ClearAll();
    }

    ClearAll () {
        this.Action = "";
        this.KeyValue = "";
        this.Parameters = "";
        this.CountDataSets = 0;
        this.moduleName = "";
        this.methodName = "";
        this.tranID = "";
        this.tranMethod = "";
        this.suiParam = "";
        this.retParam = "";
        this.DataSets = [];
    }

    AddDataSet (argInOut, argKey, argDataSet) {
        var obj = {};
        obj.InOut = argInOut;
        obj.Key = argKey;
        obj.Name = argDataSet.DataSetName;
        // 헤더가 없을 경우 헤더를 만들어서 넣어준다.
        if (argInOut === "I"){
            if (argDataSet.Header.length === 0){
                var condHeader = makeDataHeader(argDataSet);
                console.log("Since No Header, MakeDataHeader and Set:" + condHeader);
                argDataSet.SetDataHeader(condHeader);
            }
        }
        obj.DataSet = argDataSet;
        this.DataSets.push(obj);
        // In/Out DataSet만 Count한다.
        if (argInOut === "I" || argInOut === "O") this.CountDataSets++;
        // make keyvalue
        this.KeyValue = "";
        for (var i = 0; i < this.DataSets.length; i++) {
            var dataset = this.DataSets[i];
            if(i>0) this.KeyValue += ",";
            this.KeyValue += dataset.InOut;
            this.KeyValue += ":";
            this.KeyValue += dataset.Key;
            this.KeyValue += "=";
            this.KeyValue += dataset.Name;            
        }
    }

    getValue(argIdx, argName) {
        var arrObj = this.DataSets[ argIdx - 1 ];
        return arrObj[argName];
    }

    isEmpty() {
        return (this.DataSets.size() === 0);
    }

    remove (argIdx) {
        delete this.DataSets[argIdx];
    }
}


export default ObjTrSet;

